<template>
  <vs-row v-if="config.total_data" class="mt-5" align="center">
    <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
      <div>
        <div class="flex flex-row items-center mb-4">
          <small class="mr-2 font-bold">Limit: </small>
          <select class="mr-2" v-model="config.per_page">
            <option v-for="(limit, index) in limitOptions" :key="index" :value="limit" v-text="limit"/>
          </select>
        </div>
        <span class="text-muted block">Show {{total_data_shown}} of {{config.total_data}} data</span>
      </div>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="end" vs-align="center" vs-w="6">
      <vs-pagination :total="config.total_page" :max="5" v-model="config.page"></vs-pagination>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: ['config', 'initial'],
  data() {
    return {
      limitOptions: [10, 20, 50, 100]
    }
  },
  methods: {
    gotoPage() {
      this.$emit('gotoPage', this.config.page)
    },
    applyWatchers() {
      this.$watch('page', () => {
        this.gotoPage(this.config.page)
      })
    }
  },
  created() {
    this.applyWatchers()
      if(this.initial) {
        this.limitOptions.unshift(this.initial)
      }
  },
  computed: {
    total_data_shown() {
      return this.config.per_page * this.config.page - this.config.per_page + this.config.rows.length
    },
    page() {
      return this.config.page
    },
  }
}
</script>

<style>

</style>
